export var DatasetType;
(function (DatasetType) {
    DatasetType["visits"] = "per-visit-set";
    DatasetType["personVisits"] = "per-person-visit-set";
})(DatasetType || (DatasetType = {}));
export function getGraphSpec(config, datasetType, forModel) {
    // datasetType is passed in to get reactivity in the HTML
    let graphTitle;
    let xAxisLabel;
    let pointExtractor;
    if (datasetType == DatasetType.visits) {
        if (forModel) {
            graphTitle = 'Avg. model of cumulative species across visits';
            xAxisLabel = 'visits in regressed range';
        }
        else {
            graphTitle = 'Cumulative species across visits';
            xAxisLabel = 'visits';
        }
        pointExtractor = (graphData) => graphData.perVisitPoints;
    }
    else {
        if (forModel) {
            graphTitle = 'Avg. model of cumulative species across person-visits';
            xAxisLabel = 'person-visits in regressed range';
        }
        else {
            graphTitle = 'Cumulative species across person-visits';
            xAxisLabel = 'person-visits';
        }
        pointExtractor = (graphData) => graphData.perPersonVisitPoints;
    }
    return {
        graphTitle,
        xAxisLabel,
        pointSliceSpec: {
            minPointCount: config.minRecentPredictionPoints || 0,
            maxPointCount: config.maxRecentPredictionPoints || Infinity,
            recentPointsToIgnore: 0
        },
        pointExtractor
    };
}
